import { render, staticRenderFns } from "./identity_verification_arkose_app.vue?vue&type=template&id=10650abf"
import script from "./identity_verification_arkose_app.vue?vue&type=script&lang=js"
export * from "./identity_verification_arkose_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports